import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal, SectionHeader } from "./shared";
import { caseStudies } from "../../data/portfolioData";

export const CaseStudiesSection = () => {
  const [active, setActive] = useState(0);
  const study = caseStudies[active];

  return (
    <section id="case-studies" className="py-20 lg:py-28" data-testid="case-studies-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          index="07"
          eyebrow="Problem Solving"
          title="How I Solve Problems"
          description="Deep dives into real constraints, trade-offs and outcomes — because engineering is decisions, not just code."
          testId="case-studies-header"
        />

        <Reveal>
          <div className="flex flex-wrap gap-2.5 mb-10">
            {caseStudies.map((c, i) => (
              <button
                key={c.title}
                onClick={() => setActive(i)}
                className={`rounded-full border px-5 py-2 text-xs sm:text-sm font-medium transition-all duration-300 ${
                  active === i
                    ? "bg-amber-400 text-[#07090E] border-amber-400"
                    : "border-white/10 text-slate-400 hover:text-slate-100 hover:border-white/25"
                }`}
                data-testid={`case-study-tab-${i}`}
              >
                {c.title}
              </button>
            ))}
          </div>
        </Reveal>

        <AnimatePresence mode="wait">
          <motion.div
            key={active}
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-3xl border border-white/[0.07] bg-[#0F1420] p-6 sm:p-10"
            data-testid="case-study-panel"
          >
            <p className="font-code text-[11px] uppercase tracking-[0.25em] text-amber-400/90">{study.context}</p>
            <h3 className="mt-2 font-display text-xl sm:text-3xl font-bold tracking-tight text-slate-50">{study.title}</h3>

            <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {study.steps.map((s, i) => (
                <motion.div
                  key={s.label}
                  initial={{ opacity: 0, y: 14 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.08 + i * 0.06 }}
                  className={`rounded-2xl border border-white/[0.06] bg-[#0C101A] p-5 ${i === study.steps.length - 1 ? "border-emerald-400/20 bg-emerald-400/[0.04]" : ""}`}
                  data-testid={`case-step-${i}`}
                >
                  <p className={`font-code text-[10px] uppercase tracking-[0.25em] ${i === study.steps.length - 1 ? "text-emerald-400" : "text-slate-500"}`}>
                    {String(i + 1).padStart(2, "0")} — {s.label}
                  </p>
                  <p className="mt-2.5 text-sm text-slate-300 leading-relaxed">{s.text}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
};
